/**
 * Proxy the Braintree integration.
 */
var client = require('braintree-web/client'),
    paypalCheckout = require('braintree-web/paypal-checkout'),
    hostedFields = require('braintree-web/hosted-fields'),
    threeDsecure = require('braintree-web/three-d-secure');

angular.module('hjApp').service('Braintree', function ($window) {
    /**
     * Get the proxy to the Braintree Client function.
     *
     * To create an instance of the Braintree Client, do `Braintree.getClient().create(...)`.
     * @returns Proxy to the Braintree client.
     * @see {@link https://braintree.github.io/braintree-web/current/module-braintree-web_client.html#.create}
     */
    this.getClient = function getClient() {
        return client;
    };

    /**
     * Get the Hosted Fields function.
     *
     * To create a Hosted Fields instance, do `Braintree.getHostedFields().create(...)`.
     * @returns Proxy to the Hosted Fields client.
     * @see {@link https://braintree.github.io/braintree-web/current/module-braintree-web_hosted-fields.html#.create}
     */
    this.getHostedFields = function getHostedFields() {
        return hostedFields;
    };

    /**
     * Get the Paypal Checkout function.
     *
     * To create a Paypal Checkout instance, do `Braintree.getPaypalCheckout().create(...)`.
     * @returns Proxy to the Paypal Checkout.
     * @see {@link https://braintree.github.io/braintree-web/current/module-braintree-web_paypal-checkout.html#.create}
     */
    this.getPaypalCheckout = function getPaypalCheckout() {
        return paypalCheckout;
    };

    /**
     * Get the Paypal function.
     *
     * To create a Paypal button, do `Braintree.getPaypal().Buttons(...).render(...)`.
     * @returns Proxy to Paypal.
     * @see {@link https://developer.paypal.com/docs/checkout/integrate/#3-render-the-smart-payment-buttons}
     */
    this.getPaypal = function getPaypal() {
        return $window.paypal;
    };

    /**
     * Get the 3DSecure instance.
     *
     * To create the 3DS instance, do `Braintree.get3DSecure().create(...)`.
     * @returns Proxy to 3DS.
     * @see {@link https://braintree.github.io/braintree-web/current/module-braintree-web_three-d-secure.html#.create}
     */
    this.get3DSecure = function get3DSecure() {
        return threeDsecure;
    };
});
